export default {
        property_id : { attribute: 'property_id', name: "Nominated PIC"},
        livestock_class_id : { attribute: 'livestock_class_id', name: "Livestock Class"},
        purchase_type_id : { attribute: 'purchase_type_id', name: "Purchase Type"},
        average_weight : { attribute: 'average_weight', name: "Average Weight"},
        agent_advised_term : { attribute: 'agent_advised_term', name: "Term"},
        reference_code : { attribute: 'reference_code', name: "Reference"},
        bill_invoice_date : { attribute: 'bill_invoice_date', name: "Purchase date"},
        bill_due_date : { attribute: 'bill_due_date', name: "Invoice due date"},
        invoice_value_inc : { attribute: 'invoice_value_inc', name: "Total Invoice Value"},
        line_items : { attribute: 'line_items', name: "Line Items"},
        quantity : { attribute: 'quantity', name: "Head Purchased"},
        description : { attribute: 'description', name: "Description"},
        average_weight : { attribute: 'average_weight', name: "Average weight"},
        total_ex_gst : { attribute: 'total_ex_gst', name: "Total (ex)"},
        breed_category_id : { attribute: 'breed_category_id', name: "Breed"},
        sex_id : { attribute: 'sex_id', name: "Sex"},
        gst : { attribute: 'gst', name: "GST"},
        price_per_head_ex_gst : { attribute: 'price_per_head_ex_gst', name: "$/Head"},
        price_per_kg_ex : { attribute: 'price_per_kg_ex', name: "$/kg (ex)"},
        description : { attribute: 'description', name: "Description"},
        value_ex_gst : { attribute: 'value_ex_gst', name: "Total (ex)"},
        gst : { attribute: 'gst', name: "GST" },
};
